//include 14
jQuery(function () {

    window.prompt = window.prompt || {};
    window.prompt.translate = window.prompt.translate || function (str, def) {
        return def;
    };

    var playerContainers = $(".youtubeFrames");
    const youtubeVendor = "s30";

    const youtubePlaceholderImageUrl = '/index.php?type=1732176051&action=getYoutubePreview&videoid=';
    //***************helper functions*****************************************
    /**
     * formats seconds for display
     * @param  {int} totalSeconds the seconds to format
     * @return {string}              the formatted string
     */
    var formatSeconds = function (totalSeconds) {
        var hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        var minutes = Math.floor(totalSeconds / 60);
        //if hours > 0, we prepend a zero to the minutes, if needed
        if (hours > 0) minutes = ('0' + minutes).slice(-2)
        var seconds = totalSeconds % 60;
        var result = seconds;
        //if minutes > 0, we prepend a zero to the seconds, if needed
        if (minutes > 0) seconds = ('0' + seconds).slice(-2)
        var textToAppend = "Sekunden";//window.prompt.translate("seconds","Sekunden");
        if (minutes > 0) {
            result = minutes + ":" + result;
            textToAppend = "Minuten";//window.prompt.translate("minutes","Minuten");
        }
        if (hours > 0) {
            result = hours + ":" + result;
            textToAppend = "Stunden";//window.prompt.translate("hours","Stunden");
        }
        return result + " " + textToAppend;
    }

    /**
     * format a number with comma and thousand separator
     * @param  {decimal} x the number to format
     * @return {string}   the formated number
     */
    function formatNumber(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function YouTubeGetID(url){
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }

    //************************************************************************
    //*************templates**************************************************
    var iframeReplacement = '<div class="video-container">' + '<div class="video-player"></div><div class="video-poster"></div>' + '<div class="video-controls">' + '<div class="text-wrapper">' + '<div class="text">' + '<h4 class="capital video-title"></h4>' + '<div class="stats">' + '<div class="views icon-views video-views"></div>' + '<div class="time icon-clock video-minutes"></div>' + '</div>' + '</div>' + '</div>' + '<button class="play"><i class="icon-play"></i></button>' /*+ '<button class="fullscreen"><i class="icon-up-open-big"></i></button>'*/ + '</div>' + '</div>';
    //************************************************************************
    var startPlayers = function () {
        playerContainers.each(function (index) {
            var $self = $(this);
            var $parent = $self.parent();
            var isPlaying = false;
            var id = $self.attr("id") || "youtubePlayer" + index;
            var src = $self.attr("src");
            if (!src) return;
            var videoId = $self.data("video-id") || YouTubeGetID(src) || "";
            var placeholderImage = $self.data("poster") || `${youtubePlaceholderImageUrl}${videoId}`;
            var title = $self.data("video-title") || "";
            var durationClass = "";
            var duration = $self.data("video-duration") || 0;
            if (duration <= 0) {
                durationClass = "hide";
            }
            duration = formatSeconds(duration);
            var viewsClass = "";
            var views = $self.data("video-views") || 0;
            if (views <= 0) {
                viewsClass = "hide";
            }
            views = formatNumber(views);
            var replacement = $(iframeReplacement);
            $(replacement.find(".video-player").get(0)).attr("id", id);
            $(replacement.find(".video-poster").get(0)).css("background-image", 'url(' + placeholderImage + ')');
            $parent.replaceWith(replacement);

            var playerOptions = {
                videoId: videoId,
                host: 'https://www.youtube-nocookie.com',
                playerVars: {
                    autoplay: 0,
                    controls: 1,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0
                },
                events: {
                    'onStateChange': onPlayerStateChange
                }
            };
            //TPBB-1084 - always use nocookie
            //if(!readCookie("pp_allow_third_party_cookies")){
            //    playerOptions.host = 'https://www.youtube-nocookie.com';
            //}

            var player = new YT.Player(id, playerOptions);
            //*******************set the video information*********************************
            $(replacement.find(".video-title").get(0)).html(title);
            $(replacement.find(".video-views").get(0)).html(views).addClass(viewsClass);
            $(replacement.find(".video-minutes").get(0)).html(duration).addClass(durationClass);
            //if browser doesn't support fullscreen, hide the fullscreen button
            /*
            if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled && !document.mozFullScreenEnabled && !document.msFullscreenEnabled) {
                $(replacement.find(".fullscreen").get(0)).hide();
            }
            //*/
            //*****************************************************************************
            //*******************control functions*****************************************
            var control = {
                onStartPlaying: function () {
                    replacement.find(".video-poster").fadeOut(); //addClass("faded");
                    replacement.find(".video-controls").fadeOut(); //addClass("faded");
                    //replacement.find(".fullscreen").hide();
                },
                /*
                onPausePlaying: function() {
                    replacement.find(".video-poster").removeClass("faded");
                    replacement.find(".video-controls").removeClass("faded");
                    //replacement.find(".fullscreen").show();
                },
                //*/
            }
            //*****************************************************************************
            //***********************handling play click********************************************
            replacement.on("click", ".play", function () {
                //if (!isPlaying) {
                player.playVideo();
                control.onStartPlaying();
                isPlaying = true;
                //} else {
                //    player.pauseVideo();
                //}
            });
            //*****************************handling fullscreen*********************************
            /*
            replacement.on("click", ".fullscreen", function() {
                var playerElement = document.getElementById(id);
                var requestFullScreen = playerElement.requestFullScreen || playerElement.mozRequestFullScreen || playerElement.webkitRequestFullScreen;
                if (requestFullScreen) {
                    if (!isPlaying) {
                        player.playVideo();
                        control.onStartPlaying();
                        isPlaying = true;
                    }
                    requestFullScreen.bind(playerElement)();
                }
            });
            $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function() {
                if (!document.fullscreenElement) {
                    if (!isPlaying) {
                        control.onPausePlaying();
                    }
                }
            });
            //*/
            //**********************************************************************************
            //*************video events****************************************************
            //*
            function onPlayerStateChange(event) {
                switch (event.data) {
                    /*
                    case YT.PlayerState.ENDED:
                        control.onPausePlaying();
                        isPlaying = false;
                        break;
                    //*/
                    /*
                    case YT.PlayerState.PLAYING:
                        control.onStartPlaying();
                        isPlaying = true;
                        break;
                        //*/
                    /*
                case YT.PlayerState.PAUSED:
                    control.onPausePlaying();
                    isPlaying = false;
                    break;
                    //*/
                }
            }

            //*/
            //*****************************************************************************
        });
    }

    var YoutubeCMPConsentGiven = function () {
        if (typeof __cmp === 'undefined' || !__cmp) {
            // no CMP running on this page at all
            return true;
        }
        const data = __cmp('getCMPData');
        if (!data || !data.vendorConsents) {
            // __cmp exists but the real consentmanager script hasn't replaced the stub yet
            return false;
        }
        return !!data.vendorConsents[youtubeVendor]; // Youtube has the id 's30'
    }

    var setAttribute = function (iframe, name, value) {
        //TPBB-1151 we check if consent was given. If not we do not include some attributes
        let includeAttribute = true;
        if (['data-poster'].includes(name)) {
            if (!YoutubeCMPConsentGiven()) {
                includeAttribute = false;
            }
        }
        // TPBB-1157: we have to manually block youtube
        if (name == 'src' && !YoutubeCMPConsentGiven()) {
            iframe.attr('src', 'about:blank');
            iframe.attr('data-cmp-src', value);
            iframe.attr('data-cmp-vendor', youtubeVendor);
            iframe.addClass('cmplazyload');
        } else if (includeAttribute) {
            iframe.attr(name, value);
        }
    };

    var setConsentSize = function (iframe, attrs, $parent) {
        let widthAttr =
            attrs.getNamedItem('data-youtube-cmp-width') ||
            attrs.getNamedItem('data-youtube-width') ||
            {value: 0};
        widthAttr = {value: 0};
        //{value: 387};
        let heightAttr =
            attrs.getNamedItem('data-youtube-cmp-height') ||
            attrs.getNamedItem('data-youtube-height') ||
            {value: 0};
        //{value: 200};
        if (widthAttr.value == 0) {
            if (!!$parent && $parent.length > 0) {
                widthAttr = {value: $parent.width()};
                heightAttr = {value: $parent.width() * 0.56};
            }
        }
        if (widthAttr.value == 0) {
            widthAttr = {value: 387};
            heightAttr = {value: 200};
        }

        let width = widthAttr.value;
        let height = heightAttr.value;

        if (!!window.visualViewport) {
            if (width > window.visualViewport.width) {
                width = window.visualViewport.width;
                height = width * 0.56;
            }
        }

        height = height < 300 ? 300 : height;

        iframe.attr('data-cmp-preview', `${width}x${height}`);
    }
    // slack 03.01.2023: we need a timeout so a potential slider can be initialized before the cmp preview message width is determined
    setTimeout(() => {

        $(".youtube-placeholder").each((index, element) => {
            var iframe = $("<iframe tabindex='-1'></iframe>");
            var allAttributes = element.attributes;
            var foundSrc = "";
            $.each(allAttributes, (key, value) => {
                if (value.name.match(/^data-youtube-/i)) {
                    var name = value.name.replace(/^data-youtube-/i, "");
                    if (name == "src") {
                        foundSrc = value.value;
                    }
                    setAttribute(iframe, name, value.value);
                    //iframe.attr(name,value.value);
                }
            });
            setConsentSize(iframe, allAttributes, $(element));
            $(element).after(iframe);
            if ($(element).closest(".videogallery").length > 0) {
                const overlay = $(`
                <button class="videoGalleryOverlay with-background"
                     data-src="${foundSrc || iframe.attr("src")}"
                     >
                     <img src="${youtubePlaceholderImageUrl}${YouTubeGetID(foundSrc || iframe.attr("src"))}" data-cmp-src="${youtubePlaceholderImageUrl}${YouTubeGetID(foundSrc || iframe.attr("src"))}" data-cmp-vendor="${youtubeVendor}" class="cmplazyload background-image"/>
                    <i class="icon-youtube"></i>
                </button>`);
                $(element).after(overlay);
            }
        });
        $('.videogallery').on("click", ".videoGalleryOverlay", function () {
            var src = $(this).data("src");
            if (src == 'undefined') {
                var ifr = $(this).next();
                src = ifr.attr("src");
            }

            var url = new URL(src);
            url.searchParams.append('autoplay',1);
            src = url.toString();

            var lightbox = lity(src);
        });

        $(".youtube-placeholder").remove();
        playerContainers = $(".youtubeFrames");

        if (typeof (YT) == 'undefined' || typeof (YT.Player) == 'undefined') {
            window.onYouTubeIframeAPIReady = function () {
                startPlayers();
            };

            let iframeApiAppended = false;
            var appendIframeApiScript = function () {
                if (iframeApiAppended || !YoutubeCMPConsentGiven()) return;
                iframeApiAppended = true;
                $('body').append(`<script type="text/javascript" src="https://www.youtube.com/iframe_api" class="cmplazyload" data-cmp-vendor="${youtubeVendor}"></script>`);
            };

            // check right away (covers "no CMP at all" and "consent already known"),
            // and retry once the CMP actually reports a consent decision
            appendIframeApiScript();
            if (typeof __cmp !== 'undefined' && !!__cmp) {
                __cmp("addEventListener", ["consent", appendIframeApiScript, true], null);
            }
        } else {
            startPlayers();
        }
    }, 500);
})
;
